import { useState } from "react";
import {
  Grid,
  Paper,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import SwapHorizontalCircleIcon from '@mui/icons-material/SwapHorizontalCircle';

import Main from "./components/Main";

const SkillSwap = ({refreshProfiles}) => {
    const [dialogOpen, setDialogOpen] = useState(false);
  return (
    <Grid item >
      <Paper height={3}>
        <List
          sx={{
            width: "100%",
            maxWidth: 360,
            bgcolor: "background.paper",
          }}
          component="nav"
          aria-labelledby="nested-list-subheader"
        >
          <ListItemButton onClick={() => setDialogOpen(true)}>
            <ListItemIcon>
              <SwapHorizontalCircleIcon />
            </ListItemIcon>
            <ListItemText primary="Skill Swap" />
          </ListItemButton>
        </List>
      </Paper>
      <Main 
        open={dialogOpen}
        close={() => setDialogOpen(false)}
        refreshProfiles={refreshProfiles}
      />
    </Grid>
  );
};

export default SkillSwap;
